import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import validator from 'validator';
import { notifications } from '@mantine/notifications';

import { Box, Group, TextInput, Drawer, Textarea, Button, Input, Checkbox, Text, Loader, Select, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { getPropInSubLevelRole, safetyDecodeJWT, regexNoSpace, regexPhoneNumber } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import InputComponent from "../../components/general/InputComponent";
import CustomerCategorySelectorSingle from "../../components/general/CustomerCategorySelectorSingle";
import GenderMaleFemaleUngenderedSelectorSingle from "../../components/general/GenderMaleFemaleUngenderedSelectorSingle";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";

const CustomerAdd = ({
  stateMenuList,
  stateShow,
  fnShow,
  fnSuccessAdd,

  stateLoading,
  stateFlag,
  stateDefaultData,
}) => {

  const mountedRef = React.useRef(true);
  const goToNotaRef = React.useRef(null);
  const navigate = useNavigate();

  // const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorSubmitData: 'customerAdd-1',
    successSubmitData: 'customerAdd-2',
  })

  const constCustomerName = {
    id: 'addCustomerName',
    label: 'Nama Customer',
    withAsterisk: true,
    placeholder: 'Nama Customer',
    value: '',
    description: '',
    error: ''
  }

  const constCustomerIdCardNumber = {
    id: 'addCustomerIdCardNumber',
    label: 'No Kartu ID',
    withAsterisk: false,
    placeholder: 'No Kartu ID',
    value: '',
    description: '',
    error: ''
  }

  const constCustomerCategory = {
    id: 'addCustomerCategory',
    label: 'Kategori',
    withAsterisk: true,
    placeholder: 'Kategori',
    value: '',
    description: '',
    error: ''
  }

  const constCustomerGroup = {
    id: 'addCustomerGroup',
    label: 'Customer Group',
    withAsterisk: true,
    placeholder: 'Customer Group',
    value: '',
    description: '',
    error: ''
  }

  const constCustomerGender = {
    id: 'addCustomerGender',
    label: 'Gender',
    withAsterisk: true,
    placeholder: 'Gender',
    value: '1',
    description: '',
    error: ''
  }

  const constCustomerAddress = {
    id: 'addCustomerAddress',
    label: 'Alamat',
    withAsterisk: true,
    placeholder: 'Alamat',
    value: '',
    description: '',
    error: ''
  }

  const constCustomerContact = {
    id: 'addCustomerContact',
    label: 'Kontak',
    withAsterisk: false,
    placeholder: 'Kontak',
    value: '',
    description: '',
    error: ''
  }

  const constCustomerInfo = {
    id: 'addCustomerInfo',
    label: 'Keterangan',
    withAsterisk: false,
    placeholder: 'Keterangan',
    value: '',
    description: '',
    error: ''
  }

  const [data, setData] = React.useState({
    customerName: constCustomerName,
    customerIdCardNumber: constCustomerIdCardNumber,
    customerCategory: constCustomerCategory,
    customerGroup: constCustomerGroup,
    customerAddress: constCustomerAddress,
    customerContact: constCustomerContact,
    customerGender: constCustomerGender,
    customerInfo: constCustomerInfo,

    submitLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    if (Array.isArray(stateDefaultData.customerCategory) && (stateDefaultData.customerCategory.length > 0)) {
      setData(d => ({
        ...d,
        customerCategory: {
          ...d.customerCategory,
          value: stateDefaultData.customerCategory[0].customer_category_slug
        }
      }))
    }
  }, [stateDefaultData.customerCategory])

  const resetData = () => {
    setData(d => ({
      ...d,
      customerName: constCustomerName,
      customerIdCardNumber: constCustomerIdCardNumber,
      customerCategory: { ...constCustomerCategory, value: (Array.isArray(stateDefaultData.customerCategory) && (stateDefaultData.customerCategory.length > 0)) ? stateDefaultData.customerCategory[0].customer_category_slug : '' },
      customerGroup: constCustomerGroup,
      customerAddress: constCustomerAddress,
      customerContact: constCustomerContact,
      customerGender: constCustomerGender,
      customerInfo: constCustomerInfo,
    }))
  }

  const addData = () => {
    setData(d => ({
      ...d,
      customerName: { ...d.customerName, error: '' },
      customerIdCardNumber: { ...d.customerIdCardNumber, error: '' },
      customerCategory: { ...d.customerCategory, error: '' },
      customerGroup: { ...d.customerGroup, error: '' },
      customerGender: { ...d.customerGender, error: '' },
      customerAddress: { ...d.customerAddress, error: '' },
      customerContact: { ...d.customerContact, error: '' },
    }));

    if (validator.isEmpty(data.customerName.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, customerName: { ...d.customerName, error: 'Nama customer wajib diisi!', } }));
    } else if (validator.isEmpty(data.customerCategory.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, customerCategory: { ...d.customerCategory, error: 'Kategori customer wajib diisi!', } }));
    } else if (validator.isEmpty(data.customerGroup.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, customerGroup: { ...d.customerGroup, error: 'Group customer wajib diisi!', } }));
    } else if (validator.isEmpty(data.customerGender.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, customerGender: { ...d.customerGender, error: 'Gender wajib diisi!', } }));
    } else if (validator.isEmpty(data.customerAddress.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, customerAddress: { ...d.customerAddress, error: 'Alamat wajib diisi!' } }))
    }

    else if ((!validator.isEmpty(data.customerContact.value, { ignore_whitespace: true })) && (regexPhoneNumber(data.customerContact.value) === false)) {
      setData(d => ({ ...d, customerContact: { ...d.customerContact, error: 'Format kontak customer tidak valid!' } }))
    }

    else {

      setData(d => ({ ...d, submitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('customer_name', data.customerName.value);
      formDT.append('customer_category', data.customerCategory.value);
      formDT.append('customer_group_id', data.customerGroup.value);
      formDT.append('customer_id_card_number', data.customerIdCardNumber.value);
      formDT.append('customer_gender', data.customerGender.value);
      formDT.append('customer_address', data.customerAddress.value);
      formDT.append('customer_contact', data.customerContact.value ? regexPhoneNumber(data.customerContact.value) : '');
      // formDT.append('customer_contact', data.customerContact.value);
      formDT.append('customer_info', data.customerInfo.value);

      axios({
        method: 'post',
        url: BE_API_ONE + '/add_customer',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false }));

        if (response.data.flag_status === 'isset') {
          if (goToNotaRef.current.checked) {
            navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenuList.project.slug}/${stateMenuList.project.subMenu.one.flag}/${stateMenuList.project.subMenu.one.tabs.one.flag}/${response.data.customer_id}/null/gen-true`, { replace: true });
          } else {
            resetData();
            fnSuccessAdd();

            notifications.show({
              id: notificationId.current.successSubmitData,
              title: utils.notification.success.caption,
              message: 'Berhasil Tambah Data.',
              color: utils.notification.success.color,
              icon: utils.notification.success.icon,
              withBorder: true,
              autoClose: true,
            })
          }
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorSubmitData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'duplicate-contact') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: `Nomor kontak ini sudah pernah didaftarkan untuk customer "${response.data.suspect}".`,
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false }));

        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: false,
        })
      })
    }
  }

  return (
    <React.Fragment>
      <Drawer
        opened={stateShow}
        onClose={fnShow}
        withCloseButton={false}
        position="left"
        closeOnClickOutside={true}

        title={
          <Group noWrap spacing='xs'>
            <ActionIcon
              size='lg'
              variant="light"
              radius='xl'
              color="blue"
              onClick={fnShow}
            >
              <IconArrowLeft size='1.25rem' stroke={1.5} />
            </ActionIcon>

            <Text>Tambah Customer</Text>
          </Group>
        }
        size='md'

        styles={() => ({
          title: {
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }
        })}
      >
        <Box py='md'>

          <Box mb='2rem'>
            <InputComponent
              stateId={data.customerName.id}
              stateWithAsterisk={data.customerName.withAsterisk}
              stateLabel={data.customerName.label}
              stateDescription={data.customerName.description}
              statePlaceHolder={data.customerName.placeholder}
              stateValue={data.customerName.value}
              stateError={data.customerName.error}

              fnOnChange={(e) => setData(d => ({
                ...d,
                customerName: {
                  ...d.customerName,
                  value: e.target.value
                }
              }))}
            />
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel={data.customerCategory.label}
              stateWithAsterisk={data.customerCategory.withAsterisk}
              stateError={data.customerCategory.error}
              stateDescription={data.customerCategory.description}
            >
              <CustomerCategorySelectorSingle
                stateValue={data.customerCategory.value}
                fnOnChange={(val) => setData(d => ({
                  ...d,
                  customerCategory: {
                    ...d.customerCategory,
                    value: val
                  }
                }))}
                stateData={stateDefaultData.customerCategory}
                stateDataLoading={stateLoading.customerCategory}
                stateDataFlag={stateFlag.customerCategory}
              />
            </InputWrapperCustom>
          </Box>

          <InputWrapperCustom
            stateMB="1rem"
            stateLabel={
              <Group>
                <Text>{data.customerGroup.label}</Text>
                {stateLoading.customerGroup && <Loader size="xs" />}
              </Group>
            }
            stateWithAsterisk={data.customerGroup.withAsterisk}
            stateError={data.customerGroup.error}
            stateDescription={data.customerGroup.description}
          >
            <Select
              // disabled={disabledSteps.includes(stateData.projectProcess)}
              value={data.customerGroup.value}
              onChange={(val) => setData(d => ({
                ...d,
                customerGroup: {
                  ...d.customerGroup,
                  value: val
                }
              }))}
              data={[
                { value: '', label: 'Pilih Customer Group' },
                ...stateDefaultData.customerGroup.map(key => ({ value: key.customer_group_id, label: key.customer_group_name }))
              ]}

              styles={(tema) => ({
                input: {
                  backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                  "&[data-disabled=true]": {
                    color: tema.colorScheme === 'light' ? tema.colors.dark[9] : tema.colors.gray[0]
                  }
                },
                wrapper: {
                  marginTop: '.75rem'
                }
              })}
            />
          </InputWrapperCustom>

          <Box mb='2rem'>
            <InputComponent
              stateId={data.customerIdCardNumber.id}
              stateWithAsterisk={data.customerIdCardNumber.withAsterisk}
              stateLabel={data.customerIdCardNumber.label}
              stateDescription={data.customerIdCardNumber.description}
              statePlaceHolder={data.customerIdCardNumber.placeholder}
              stateValue={data.customerIdCardNumber.value}
              stateError={data.customerIdCardNumber.error}

              fnOnChange={(e) => setData(d => ({
                ...d,
                customerIdCardNumber: {
                  ...d.customerIdCardNumber,
                  value: regexNoSpace(e.target.value)
                }
              }))}
            />
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel={data.customerGender.label}
              stateWithAsterisk={data.customerGender.withAsterisk}
              stateError={data.customerGender.error}
              stateDescription={data.customerGender.description}
            >
              <GenderMaleFemaleUngenderedSelectorSingle
                stateValue={data.customerGender.value}
                fnOnChange={(val) => setData(d => ({
                  ...d,
                  customerGender: {
                    ...d.customerGender,
                    value: val
                  }
                }))}
              />
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputComponent
              stateId={data.customerAddress.id}
              stateWithAsterisk={data.customerAddress.withAsterisk}
              stateLabel={data.customerAddress.label}
              stateDescription={data.customerAddress.description}
              statePlaceHolder={data.customerAddress.placeholder}
              stateValue={data.customerAddress.value}
              stateError={data.customerAddress.error}

              fnOnChange={(e) => setData(d => ({
                ...d,
                customerAddress: {
                  ...d.customerAddress,
                  value: e.target.value
                }
              }))}
            />
          </Box>

          <Box mb='2rem'>
            <Input.Wrapper
              id={data.customerContact.id}
              withAsterisk={data.customerContact.withAsterisk}
              label={data.customerContact.label}
              description={data.customerContact.description}
            >
              <TextInput
                variant='default'
                placeholder='Kontak'
                value={data.customerContact.value}
                error={data.customerContact.error}
                onChange={(e) => setData(d => ({
                  ...d,
                  customerContact: {
                    ...d.customerContact,
                    value: e.target.value
                  }
                }))}

                mb='xs'
              />
            </Input.Wrapper>
          </Box>

          <Box mb='2rem'>
            <Textarea
              value={data.customerInfo.value}
              onChange={(e) => setData(d => ({
                ...d,
                customerInfo: {
                  ...d.customerInfo,
                  value: e.target.value
                }
              }))}

              autosize
              minRows={3}
              maxRows={5}
              label={data.customerInfo.label}
              placeholder={data.customerInfo.placeholder}
              error={data.customerInfo.error}
              description={data.customerInfo.description}
              withAsterisk={data.customerInfo.withAsterisk}
            />
          </Box>

          <Checkbox
            ref={goToNotaRef}
            defaultChecked={false}
            label='Lanjut Nota Transaksi Setelah Berhasil Simpan Data'

            mb='2rem'
            sx={{
              userSelect: 'none'
            }}
          />

          <Group position="apart" noWrap spacing='xs' my='xl'>
            <Button
              fullWidth
              variant="default"
              color='gray'
              onClick={resetData}
            >
              Reset
            </Button>

            <Button
              fullWidth
              // variant="default"
              // color='teal'
              loading={data.submitLoading}
              onClick={addData}
            >
              Submit
            </Button>
          </Group>

        </Box>
      </Drawer>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </React.Fragment>
  )
}

export default CustomerAdd;